import { connect } from 'react-redux';
import { adjustBoligagent } from '../redux/modules/boligagents';
import { getContact, setLastDwelling } from '../redux/modules/dwelling';
import { notificationLog } from '../redux/modules/app';
import Dwelling from './container';

export default connect(
  ({
    dwelling,
    boligagents: { current },
    cities,
    auth: { user, existingUser },
    subscriptions: { subscriber }
  }) => ({
    dwelling,
    current,
    statusCode: dwelling.statusCode,
    city: cities.current,
    contact: dwelling.contact,
    cities: cities.list,
    aliases: cities.aliases,
    user,
    existingUser,
    subscriber
  }),
  { getContact, setLastDwelling, adjustBoligagent, notificationLog }
)(Dwelling);
